<script setup lang="ts">
import YscIconsArrowBottom from './YscIconsArrowBottom.vue'
import { ref } from '#imports'

interface Props {
  isFaq?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  isFaq: true,
})
const show = ref(false)
</script>

<template>
  <div
    :itemscope="props.isFaq"
    :itemprop="props.isFaq ? 'mainEntity' : undefined"
    :itemtype="props.isFaq ? 'https://schema.org/Question' : undefined"
  >
    <button
      class="focus-visible:ring-peacock-300 relative flex w-full items-center justify-between gap-6 rounded py-6 focus-visible:z-10 focus-visible:ring-2"
      @click="show = !show"
    >
      <h3
        :itemprop="props.isFaq ? 'name' : undefined"
        class="max-w-prose text-left font-semibold lg:text-xl"
      >
        <slot name="title" />
      </h3>
      <YscIconsArrowBottom
        class="h-5 w-5 shrink-0 transition-all"
        :class="{ 'rotate-180': show }"
      />
    </button>
    <div
      v-show="show"
      :itemscope="props.isFaq"
      :itemprop="props.isFaq ? 'acceptedAnswer' : undefined"
      :itemtype="props.isFaq ? 'https://schema.org/Answer' : undefined"
      class="overflow-hidden text-gray-500"
    >
      <div
        class="max-w-prose pb-6"
        :itemprop="props.isFaq ? 'text' : undefined"
      >
        <slot name="contentBlock" />
      </div>
    </div>
  </div>
</template>
